var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"color":"primary","large":""},on:{"click":function(){
      _vm.$router.push({ name: 'assets_products' })
    }}},[_vm._v(" View Assets & Products Summary ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }